

import React, { memo } from 'react';
import cx from 'classnames';
import LabelWrapper from '../../LabelWrapper';
import {
  DISABLED,
  TOGGLE,
  SWITCH,
  SWITCH_INPUT,
  SLIDER_BEFORE,
  SLIDER } from
'../styles/switch';












function generateContainerClassName(checked, disabled) {
  return cx({
    'switch--checked': checked,
    'switch--disabled': disabled
  });
}

function onChangeHandler(onChange, checked) {
  if (!onChange) {return onChange;}

  return (evt) => {
    evt.preventDefault();

    onChange(!checked);
  };
}

function Switch({
  id = 'switchid',
  checked,
  disabled,
  label,
  className,
  onChange,
  labelProps
}) {
  const onChangeFunction = onChangeHandler(onChange, checked);
  const inputContainerAttributes = generateContainerClassName(checked, disabled);
  const inputTypeClassname = 'switch--toggle';

  return (
    <LabelWrapper {...labelProps} id={id} label={label}>
      <div className={cx(inputTypeClassname, TOGGLE, className)}>
        <label
          className={cx(
            'switch',
            inputContainerAttributes,
            SWITCH,
            {
              [DISABLED]: disabled
            }
          )}
          htmlFor={id}>

          <input
            id={id}
            className={cx('switch-input', SWITCH_INPUT)}
            type="checkbox"
            value={checked}
            checked={checked}
            onClick={onChangeFunction}
            disabled={disabled}
            readOnly />

          <div>
            <span
              className={cx(
                'slider-before',
                { 'slider-before--checked': checked },
                SLIDER_BEFORE({ checked })
              )} />

            <span
              className={cx(
                'slider',
                { 'slider--checked': checked },
                SLIDER({ checked })
              )} />

          </div>
        </label>
      </div>
    </LabelWrapper>);

}

export default memo(Switch);